export default __webpack_public_path__ + "static/media/verified-true.bf0f70b0.svg";